function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 3.8637,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 61.958,
  cy: 63.839,
  r: 60.675
}), /*#__PURE__*/React.createElement("path", {
  d: "m43.837 20.425s16.515 8.357 18.131 9.165c1.617 0.808 22.562 9.272 24.582 9.878 2.021 0.606 19.225 6.126 19.225 6.126"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.547 82.49s8.559-17.018 9.367-18.634 9.271-22.563 9.877-24.583c0.606-2.021 6.039-18.926 6.039-18.926"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.486 82.643s18.399 5.422 20.114 5.994c1.714 0.57 22.02 9.03 23.877 10.03 1.856 1 18.038 9.207 18.038 9.207"
}), /*#__PURE__*/React.createElement("path", {
  d: "m105.81 45.564s-8.44 16.999-9.249 18.615-9.271 22.563-9.877 24.583c-0.605 2.021-6.104 19.051-6.104 19.051"
}), /*#__PURE__*/React.createElement("path", {
  d: "m79.962 20.18s5.857 17.676 6.429 19.391c0.571 1.714 9.397 22.511 10.397 24.368s9.238 17.985 9.238 17.985"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.24 46.117s18.128-5.828 19.843-6.399c1.714-0.572 22.509-9.398 24.366-10.398s17.453-9.14 17.453-9.14"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.24 46.209s9.07 16.971 9.878 18.587 9.185 21.958 9.791 23.978c0.606 2.021 6.328 19.223 6.328 19.223"
}), /*#__PURE__*/React.createElement("path", {
  d: "m105.98 82.022s-17.873 5.896-19.587 6.467c-1.714 0.57-22.509 9.398-24.366 10.398s-17.651 9.111-17.651 9.111"
}), /*#__PURE__*/React.createElement("polygon", {
  transform: "translate(-1.8818 .31363)",
  points: "45.774 20.129 63.92 2.953 81.905 19.835 106.67 20.787 107.69 45.281 124.38 63.513 107.86 81.61 107 106.14 82.458 107.56 64.657 124.26 46.057 107.68 21.718 107.01 20.368 82.268 3.211 64.374 20.153 45.772 20.644 20.971"
}), /*#__PURE__*/React.createElement("line", {
  x1: 5.7792,
  x2: 18.209,
  y1: 41.052,
  y2: 46.147
}), /*#__PURE__*/React.createElement("line", {
  x1: 38.651,
  x2: 43.837,
  y1: 7.8096,
  y2: 20.487
}), /*#__PURE__*/React.createElement("line", {
  x1: 84.842,
  x2: 79.993,
  y1: 7.7176,
  y2: 20.057
}), /*#__PURE__*/React.createElement("line", {
  x1: 117.93,
  x2: 105.77,
  y1: 40.438,
  y2: 45.564
}), /*#__PURE__*/React.createElement("line", {
  x1: 105.98,
  x2: 118.21,
  y1: 81.973,
  y2: 86.865
}), /*#__PURE__*/React.createElement("line", {
  x1: 80.576,
  x2: 85.637,
  y1: 107.94,
  y2: 120
}), /*#__PURE__*/React.createElement("line", {
  x1: 44.244,
  x2: 39.547,
  y1: 107.93,
  y2: 120.36
}), /*#__PURE__*/React.createElement("line", {
  x1: 18.424,
  x2: 6.3012,
  y1: 82.582,
  y2: 87.77
}), /*#__PURE__*/React.createElement("circle", {
  cx: 198.58,
  cy: 63.596,
  r: 60.675
}), /*#__PURE__*/React.createElement("path", {
  d: "m180.46 20.182s16.515 8.357 18.131 9.165c1.617 0.808 22.562 9.272 24.582 9.878 2.021 0.606 19.225 6.126 19.225 6.126"
}), /*#__PURE__*/React.createElement("path", {
  d: "m155.17 82.247s8.559-17.018 9.367-18.634 9.271-22.563 9.877-24.583c0.606-2.021 6.039-18.926 6.039-18.926"
}), /*#__PURE__*/React.createElement("path", {
  d: "m155.1 82.4s18.399 5.422 20.114 5.994c1.714 0.57 22.02 9.03 23.877 10.03 1.856 1 18.038 9.207 18.038 9.207"
}), /*#__PURE__*/React.createElement("path", {
  d: "m242.42 45.321s-8.44 16.999-9.249 18.615-9.271 22.563-9.877 24.583c-0.605 2.021-6.104 19.051-6.104 19.051"
}), /*#__PURE__*/React.createElement("path", {
  d: "m216.58 19.937s5.857 17.676 6.429 19.391c0.571 1.714 9.397 22.511 10.397 24.368s9.238 17.985 9.238 17.985"
}), /*#__PURE__*/React.createElement("path", {
  d: "m154.86 45.874s18.128-5.828 19.843-6.399c1.714-0.572 22.509-9.398 24.366-10.398s17.453-9.14 17.453-9.14"
}), /*#__PURE__*/React.createElement("path", {
  d: "m154.86 45.966s9.07 16.971 9.878 18.587 9.185 21.958 9.791 23.978c0.606 2.021 6.328 19.223 6.328 19.223"
}), /*#__PURE__*/React.createElement("path", {
  d: "m242.6 81.779s-17.873 5.896-19.587 6.467c-1.714 0.57-22.509 9.398-24.366 10.398-1.857 1-17.651 9.111-17.651 9.111"
}), /*#__PURE__*/React.createElement("polygon", {
  transform: "translate(134.74 .070679)",
  points: "107 106.14 82.458 107.56 64.657 124.26 46.057 107.68 21.718 107.01 20.368 82.268 3.211 64.374 20.153 45.772 20.644 20.971 45.774 20.129 63.92 2.953 81.905 19.835 106.67 20.787 107.69 45.281 124.38 63.513 107.86 81.61"
}), /*#__PURE__*/React.createElement("line", {
  x1: 142.4,
  x2: 154.83,
  y1: 40.809,
  y2: 45.904
}), /*#__PURE__*/React.createElement("line", {
  x1: 175.27,
  x2: 180.46,
  y1: 7.5667,
  y2: 20.244
}), /*#__PURE__*/React.createElement("line", {
  x1: 221.46,
  x2: 216.61,
  y1: 7.4747,
  y2: 19.814
}), /*#__PURE__*/React.createElement("line", {
  x1: 254.55,
  x2: 242.39,
  y1: 40.195,
  y2: 45.321
}), /*#__PURE__*/React.createElement("line", {
  x1: 242.6,
  x2: 254.83,
  y1: 81.73,
  y2: 86.622
}), /*#__PURE__*/React.createElement("line", {
  x1: 217.19,
  x2: 222.26,
  y1: 107.69,
  y2: 119.76
}), /*#__PURE__*/React.createElement("line", {
  x1: 180.86,
  x2: 176.17,
  y1: 107.69,
  y2: 120.11
}), /*#__PURE__*/React.createElement("line", {
  x1: 155.04,
  x2: 142.92,
  y1: 82.339,
  y2: 87.527
}));

const SvgRoundPair = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Foreground",
  width: 260,
  height: 127.33,
  enableBackground: "new 0 0 127.333 127.333",
  viewBox: "0 0 260 127.33",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRoundPair, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/round-pair.4f2cb3af.svg";
export { ForwardRef as ReactComponent };